import React from "react";
import { Box, Grid, Slide, Typography, CardMedia } from "@mui/material";
import { SecondaryStyle } from "../fonts";
import SwipeableTextMobileStepper from "./MobileStepper";

import LD from "../assets/Page6LD.webp";

import Carousel1Image1 from "../assets/Page6LA1.webp";
import Carousel1Image2 from "../assets/Page6LA2.webp";

import Carousel2Image1 from "../assets/Page6LB1.webp";
import Carousel2Image2 from "../assets/Page6LB2.webp";
import Carousel2Image3 from "../assets/Page6LB3.webp";
import Carousel3Image1 from "../assets/Page6RA1.webp";
import Carousel3Image2 from "../assets/Page6RA2.webp";

//@ts-ignore
import RB from "../assets/Page6RB.mp4";

const carousel1Images = [Carousel1Image1, Carousel1Image2];
const carousel2Images = [Carousel2Image1, Carousel2Image2, Carousel2Image3];
const carousel3Images = [Carousel3Image1, Carousel3Image2];

const Page6 = (props) => {
  const { checked, isReverse } = props;

  return (
    <Slide
      direction={isReverse ? "right" : "left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          width: "100vw",
          height: { xs: "100%", sm: "100vh" },
          overflow: { xs: "auto", sm: "hidden" },
        }}
      >
        <Grid container sx={{ height: "100%" }} id="scrollTarget">
          {/* First Half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{
                height: "100%",
                borderTop: { xs: "1vh solid #fff", sm: "none" },
              }}
            >
              {/** */}
              <Grid item xs={12} sm={6}>
                <Grid container direction={"row"} sx={{ height: "100%" }}>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderBottom: ".5vh solid #fff",
                      maxHeight: "50vh",
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },

                      height: {
                        xs: "46vh",
                        sm: "100%",
                      },
                      borderRadius: { xs: "16px", sm: "0vh" },
                      backgroundImage: `url('${LD}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      height: { xs: "36vh", sm: "100%" },
                      maxHeight: "50vh",
                      borderBottom: ".5vh solid #fff",
                      borderTop: { xs: ".5vh solid #fff", sm: "none" },

                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },

                      borderRadius: { xs: "16px", sm: "0vh" },
                    }}
                  >
                    <SwipeableTextMobileStepper
                      images={carousel1Images}
                      autoplay={false}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  maxHeight: "50vh",
                  borderTop: ".3vh solid #fff",
                  height: {
                    xs: "36vh",
                    sm: "100%",
                  },
                  borderRight: {
                    xs: "1vh solid #fff",
                    sm: ".5vh solid #fff",
                  },
                  borderLeft: {
                    xs: "1vh solid #fff",
                    sm: "none",
                  },
                  borderBottom: {
                    xs: ".5vh solid #fff",
                    sm: "none",
                  },
                }}
              >
                <SwipeableTextMobileStepper images={carousel2Images} />
              </Grid>
            </Grid>
          </Grid>

          {/* 2nd half */}
          <Grid item xs={12} sm={6}>
            <Grid
              container
              direction={{ xs: "row", sm: "column" }}
              sx={{ height: "100%" }}
            >
              <Grid item xs={12} sm={6}>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    maxHeight: { xs: "82vh", sm: "100%" },
                    borderTop: {
                      xs: ".5vh solid #fff",
                      sm: "none",
                    },
                  }}
                >
                  {/**RC */}
                  <Grid
                    item
                    xs={12}
                    sx={{
                      maxHeight: "50vh",
                      borderBottom: ".5vh solid #fff",
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },

                      borderRadius: { xs: "16px", sm: "0vh" },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      height: {
                        xs: "35.5vh",
                        sm: "50vh",
                      },
                    }}
                  >
                    <SwipeableTextMobileStepper images={carousel3Images} />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction={"row"}
                  sx={{
                    borderTop: ".5vh solid #fff",
                  }}
                >
                  {/* RD */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      px: { xs: 1.5, md: 1.5, lg: 2, xl: 3 },
                      pb: { xs: 1.5 },
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        ...SecondaryStyle,

                        textAlign: { xs: "justify", sm: "left" },
                        "@media (orientation: landscape)": {
                          fontSize: { xs: "1vw", md: "1vw", lg: "0.95vw" },
                          lineHeight: {
                            xs: "1.5vw",
                            md: "1.5vw",
                            lg: "1.5vw",
                          },
                        },
                        "@media (orientation: portrait)": {
                          fontSize: { xs: "1.7vh", sm: "1vh" },
                          lineHeight: {
                            xs: "2vh",
                            sm: "1.5vh",
                            md: "1.5vh",
                            lg: "1.5vh",
                          },
                          paddingTop: {
                            xs: "1vh",
                            sm: "2vh",
                            md: "2vh",
                            lg: "2vh",
                          },
                        },
                      }}
                    >
                      Upstairs, the second and third bedrooms are cozy and
                      bright, perfect for children, guests, or even a home
                      office. Each room offers ample space for restful sleep or
                      flexible use, filled with natural light and a calming
                      atmosphere. The adjacent bathroom is both functional and
                      stylish, with clean, classic design elements and modern
                      touches. Its size makes it ideal for a growing family,
                      ensuring comfort and practicality. These rooms are
                      adaptable, offering comfort today and flexibility for
                      whatever the future brings.
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    sx={{
                      borderBottom: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderRight: {
                        xs: "1vh solid #fff",
                        sm: "none",
                      },
                      borderLeft: {
                        xs: "1vh solid #fff",
                        sm: ".5vh solid #fff",
                      },

                      maxHeight: {
                        xs: "46vh",
                        sm: "50vh",
                      },
                      height: { xs: "100%", sm: "50vh" },
                    }}
                  >
                    <CardMedia
                      component={"video"}
                      sx={{
                        borderRadius: { xs: "16px", sm: "0vh" },
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "bottom",
                      }}
                      src={RB}
                      autoPlay
                      muted
                      loop
                      playsInline
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default Page6;
